module.exports = __webpack_public_path__ + "static/media/akerbar_223129.52902296.png";